<template>
    <div>
        <h1>Share myflow</h1>
        <h2>Boost your buddy's biz</h2>

        <p>Got a friend in need? Share a smart business system, packed with features for growth. Spread the word about myflow!</p>

        <button-success
            @click="shareSlideout = true"
        >
            Share myflow
        </button-success>

        <slideout-with-slots
            v-if="shareSlideout"
            @close="shareSlideout = false"
            max-width-class="max-w-[90vw] md:max-w-screen"
        >
            <template #title>
                <h2>
                    Share myflow
                </h2>
            </template>
            <template #body>

                <div class="grid-cols-5 gap-8 md:grid">
                    <div class="col-span-1">
                        </div>
                    <div class="col-span-3">
                        <p>
                            Invite a friend to myflow. They will receive an e-mail with a link to sign up for free.
                        </p>
                        <div>
                            <form @submit.prevent="handleSubmit">
                                <input-text
                                    label="Name"
                                    type="text"
                                    maxlength="100"
                                    class="!mb-2"
                                    id="invite-name"
                                    v-model:content="formData.name"
                                    placeholder="Name"
                                    required
                                ></input-text>
                                <input-text
                                    label="E-mail address"
                                    type="email"
                                    maxlength="100"
                                    class=""
                                    id="invite-email"
                                    v-model:content="formData.email"
                                    placeholder="E-mail address"
                                    required
                                ></input-text>

                                <div v-if="data.communities != null">
                                    <p class="text-sm">
                                        Do you also want to invite them to a community?
                                    </p>

                                    <button-bar
                                        size="sm"
                                        :options="[
                                            { label: 'Yes', name: 'yes' },
                                            { label: 'No', name: 'no' }
                                        ]"
                                        :selectedOptionName="formData.inviteToCommunity"
                                        @select="formData.inviteToCommunity = $event.name"
                                    />

                                    <div
                                        v-if="formData.inviteToCommunity === 'yes'"
                                    >
                                        <p class="text-sm">
                                            Select the communities you want to invite the user to. The community invites are valid for 30 days.
                                        </p>
                                        <input-checkboxes
                                            :options="data.communities.map(c => ({ label: c.name, value: c.id }))"
                                            v-model:content="formData.community"
                                        />
                                    </div>
                                </div>

                                <div class="flex justify-stretch">
                                    <button type="submit" class="block w-full">
                                        <button-success
                                            size="sm"
                                            class="justify-center w-full"
                                        >
                                            Send invite
                                        </button-success>
                                    </button>
                                </div>

                                <p v-if="responseMessage" class="mt-2" :class="{'text-green-900': response?.data?.success, 'text-red-800': !response?.data?.success}">
                                    {{ responseMessage }}
                                    <span v-if="response?.data?.success" class="ml-2">
                                        (Closing in {{ countdown }} seconds)
                                    </span>
                                </p>
                            </form>

                        </div>
                    </div>
                </div>

            </template>
        </slideout-with-slots>
    </div>
</template>

<script setup>
    import { ref, onMounted } from 'vue';
    import axios from 'axios';

    const shareSlideout = ref(false);

    const data = ref([]);

    const formData = ref({
        name: '',
        email: '',
        inviteToCommunity: 'no',
        community: []
    });

    const responseMessage = ref('');
    const response = ref(null);
    const countdown = ref(10);
    let countdownInterval = null;

    const startCountdown = () => {
        countdown.value = 10;
        countdownInterval = setInterval(() => {
            countdown.value--;
            if (countdown.value <= 0) {
                clearInterval(countdownInterval);
                shareSlideout.value = false;
            }
        }, 1000);
    };

    const handleSubmit = async () => {
        try {
            response.value = await axios.post(route('boIndex.dashboardV2SharingInvite'), {
                name: formData.value.name,
                email: formData.value.email,
                inviteToCommunity: formData.value.inviteToCommunity,
                community: formData.value.community
            });

            if (response.value.data.success) {
                formData.value = {
                    name: '',
                    email: '',
                    inviteToCommunity: 'no',
                    community: []
                };
                startCountdown();
            }

            responseMessage.value = response.value.data.message;
        } catch (error) {
            response.value = error.response;
            responseMessage.value = error.response?.data?.message || 'An error occurred while sending the invite.';
        }
    };

    const fetchData = async () => {
        try {
            const response = await axios.get(route('boIndex.dashboardV2Sharing'));
            data.value = response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    onMounted(fetchData);
</script>

<style scoped>

</style>
